import { Extension } from "@tiptap/core";

export const VariableKeyboardShortCut = Extension.create({
  name: "variableKeyboardShortCut",

  addKeyboardShortcuts() {
    return {
      "Mod-[": () => this.editor.commands.insertVariable(),
    };
  },
});
